module.exports = __webpack_public_path__ + "static/img/case_detail_04_2.007390d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_04_2.png
// module id = rAX1
// module chunks = 34